// Prints a list of terms with year separators
export const prettyPrintTerms = (listOfTerms, displayYear = true) => {
  if (!listOfTerms) return '';

  let text = '';
  for (let i = 0; i < listOfTerms.length; i++) {
    const isLastItem = i === listOfTerms.length - 1;
    const comma = isLastItem ? '' : ', ';
    const year = displayYear && isLastItem ? ' years' : '';

    text += listOfTerms[i] + comma + year;
  }

  return text;
};
